import '../style/oops.css';

export default function Oops() {
  return (
    <div className="oops-content-container content-container">
      <img className="hero" src="/oh_ship.jpg" alt="ship in distress" />
      <span className="oops">
        <span className="top-line">It looks like you&apos;ve steered off course.</span>
        <br />
        The address you&apos;ve entered doesn&apos;t exist.
        <br />
        If you feel this is in error, please click the help bubble on the lower right to let us know.
        <br />
        Otherwise, use the above links to get back to charted waters.
        <br />
        Thank you.
      </span>
    </div>
  );
}
